import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "../../ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import React from "react";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import { useGetAllInkleCPATeamsQuery } from "store/apis/internalTeamSetting";
import {
  FILTER_SERVICE_TEAM,
  UNASSIGNED_OPTION,
} from "../Task1120FilterOptions";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const ServiceTeamColumnHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
}) => {
  const { isAdmin } = useRoleBasedView();
  const { data: teamOptions = [] } = useGetAllInkleCPATeamsQuery(
    { accessibleTeams: "CPA_TEAM" },
    { skip: !isAdmin }
  );

  const updatedOptions = [
    { uuid: UNASSIGNED_OPTION, name: "Unassigned" },
    ...teamOptions,
  ];

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>Service Team</div>
      <ColumnHeaderMultiSelectFilter
        filterName={FILTER_SERVICE_TEAM}
        options={updatedOptions.map((team) => ({
          value: team.uuid,
          label: team.name,
        }))}
        selected={values.SERVICE_TEAM || null}
        updateFilter={updateFilter}
      />
    </div>
  );
};
